import { round, floor } from 'lodash';

export const roundDecimals = (value) => round(value, 2).toLocaleString(undefined,
  { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const formatNoDecimals = (value) => value.toLocaleString();
// returns number for requests
export const roundAmountsInput = (value) => floor(value, 2);
